import { render, staticRenderFns } from "./SetMcq.vue?vue&type=template&id=0a7326c3&scoped=true"
import script from "./SetMcq.vue?vue&type=script&lang=js"
export * from "./SetMcq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7326c3",
  null
  
)

export default component.exports